module.exports = __webpack_public_path__ + "static/media/400110_02.ac25a2a1.png";